// extracted by mini-css-extract-plugin
module.exports = {"root":"ReviewSection_root__NdQlW"};